var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 22,
    viewBox: "0 0 27 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.20535C0.28 2.36535 1.73999 0.915352 3.60999 0.735352H23.3C25.21 0.885352 26.74 2.39535 26.95 4.29535V17.5553C26.82 19.5353 25.23 21.1354 23.25 21.2654H3.57001C1.81001 21.0954 0.20001 19.5554 0.0100098 17.7854V4.20535H0ZM3.66998 2.32535C2.52998 2.47535 1.69002 3.35535 1.58002 4.49535V17.4953C1.70002 18.6853 2.61 19.5853 3.81 19.6853H23.13C24.35 19.5853 25.26 18.6653 25.37 17.4453V4.54535C25.26 3.32535 24.37 2.40534 23.13 2.30534L3.66998 2.32535Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9396 6.27574C11.0496 6.25574 11.1697 6.25574 11.2797 6.27574C13.3697 7.59574 15.5896 8.78575 17.6296 10.1857C17.7496 10.2657 17.9397 10.3657 18.0297 10.4757C18.3197 10.8257 18.2597 11.2857 17.9497 11.6057C15.8497 12.7657 13.8097 14.4057 11.7097 15.5157C11.1097 15.8357 10.6596 15.8557 10.3496 15.1557C10.3296 12.3657 10.2796 9.54574 10.3796 6.75574C10.4496 6.53574 10.7197 6.31575 10.9497 6.26575L10.9396 6.27574ZM11.8997 8.46574V13.5157L15.8997 10.9657L11.8997 8.46574Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.108ca1283bc9d884d8af562ce5e3cfd9.svg";
export { ForwardRef as ReactComponent };